import 'owl.carousel';

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $(document).ready(function () {

      // JavaScript to be fired on all pages
        var $hamburger = $(".hamburger");
        $hamburger.on("click", function() {
            $hamburger.toggleClass("is-active");
        });

      var w = 700;

      if($(window).width() <= 767) {
        w = 250;
      }

      $(window).scroll(function(){
        if ($(window).scrollTop() >= w) {
          $('header.banner').addClass('fixed-header');
        }
        else {
          $('header.banner').removeClass('fixed-header');
        }
      });

        $('a[href^="#"]').click(function (e) {
            var url = $(this).attr('href');
            var type = url.split('#');
            if (typeof type[1] !== "undefined") {
                e.preventDefault();
                $('html, body').animate({
                    scrollTop: $('#'+type[1]).offset().top,
                }, 1000);
            }
        });

        var hash = window.location.hash;
        // now scroll to element with that id
        if(hash) {
            $('html, body').animate({ scrollTop: $(hash).offset().top });
        }

        $('input[name="input_1"]').change(function() {
            $('input[name="input_9"]').val($(this).val());
        });

        $('input[name="input_2"]').change(function() {
            $('input[name="input_8"]').val($(this).val());
        });


      $(document).ready(function(){
        $('.video-carousel').owlCarousel({
          items: 1,
          loop: true,
          nav: true,
          autoplay: false,
          autoplayTimeout: 5500,
          autoplayHoverPause: false,
          mouseDrag: false,
          animateOut: 'fadeOut',
          smartSpeed:450,
          stagePadding: 0,
          onInitialized: adjustVideoHeight,
          onResized: adjustVideoHeight,
          onRefreshed: adjustVideoHeight,
        });

        function adjustVideoHeight() {
          var $section = $('.video-bg-section');
          if ($section.length === 0) return;

          var sectionHeight = $section.outerHeight();

          // gunakan .height() agar tidak perlu object literal
          $('.video-carousel, .video-carousel .video-bg').each(function () {
            $(this).height(sectionHeight);
          });
        }

        // Saat window di-resize
        $(window).on('resize', function () {
          adjustVideoHeight();
        });

        // update juga setelah beberapa delay untuk menangani font/images yang load terlambat
        setTimeout(adjustVideoHeight, 200);
        setTimeout(adjustVideoHeight, 500);
        setTimeout(adjustVideoHeight, 1000);

        $('.owl-carousel').owlCarousel({
          items:1,
          loop:true,
          nav:false,
          autoplay:true,
          autoplayTimeout:5500,
          autoplayHoverPause:false,
          mouseDrag: false,
          animateOut: 'fadeOut',
          smartSpeed:450,
          stagePadding: 0,
        });

        /*----------  video Modal Play  ----------*/

        var $videoSrc;
        $('.video-btn').click(function() {
            $videoSrc = $(this).data( "src" );
              console.log($videoSrc);
        });

        // autoplay
        $('#videoModal').on('shown.bs.modal', function () {
          $("#video").attr('src',$videoSrc + "?autoplay=1&modestbranding=1&rel=0&showinfo=0&color=white" );
          $("#hpVid").addClass('hide');
        });

        // stop playing
        $('#videoModal').on('hide.bs.modal', function () {
            // a poor man's stop video
            $("#video").attr('src',$videoSrc);
            $("#hpVid").removeClass('hide');
        });

          $('#v-pills-tab a').on('click', function (e) {
              e.preventDefault();
              $(this).tab('show');

              if(this.id == 'community-tab') {
                $('#pledge-your-support').addClass('d-block');
                $('#pledge-your-support').removeClass('d-none');
              } else {
                  $('#pledge-your-support').addClass('d-none');
                  $('#pledge-your-support').removeClass('d-block');
              }

          })

          /*----------  Facts Slider  ----------*/

          $('.timeline-for').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: true,
            adaptiveHeight: true,
            asNavFor: '.timeline-nav',
          });
          $('.timeline-nav').slick({
            infinite: true,
            slidesToShow: 8,
            slidesToScroll: 1,
            asNavFor: '.timeline-for',
            centerMode: true,
            centerPadding: '0',
            focusOnSelect: true,
            arrows: true,
          });

          /*----------  Facts Slider  ----------*/

          $('.facts-slider').slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 3,
            dots: true,
            arrows: true,
              responsive: [
                  {
                      breakpoint: 1024,
                      settings: {
                          slidesToShow: 2,
                          slidesToScroll: 2,
                          dots: true,
                      },
                  },
                  {
                      breakpoint: 600,
                      settings: {
                          slidesToShow: 2,
                          slidesToScroll: 2,
                      },
                  },
                  {
                      breakpoint: 480,
                      settings: {
                          slidesToShow: 1,
                          slidesToScroll: 1,
                      },
                  },
              ],
          });


      }); //end doc.ready

    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js